const EMPTY_TEXT_CHARACTERS = /\uFFFC/g

export function stripEmptyTextCharacters(text: string) {
  return text.replace(EMPTY_TEXT_CHARACTERS, '')
}

export function hasMessageText(text?: string | null) {
  return Boolean(text && stripEmptyTextCharacters(text).trim())
}
